import { render, staticRenderFns } from "./AdminTopbar.vue?vue&type=template&id=3b1d01e1&scoped=true"
import script from "./AdminTopbar.vue?vue&type=script&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&lang=js"
import style0 from "./AdminTopbar.vue?vue&type=style&index=0&id=3b1d01e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d01e1",
  null
  
)

export default component.exports